module.exports = __webpack_public_path__ + "img/petstairs04.ac5b3916.jpg";